import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, checkIsSubTeamleiter } from '../../api';

function Login({ onLogin, switchToRegister }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await login(email, password);

      if (data.success) {

        if (data.user.role_type) {
          const roleType = parseInt(data.user.role_type, 10);
          data.user.isAdmin = roleType === 1;
          data.user.isTeamlead = roleType === 2;
          data.user.isOrgLeader = roleType === 3;
          data.user.isCallcenterLeader = roleType === 4;
          data.user.isCallcenterMitarbeiter = roleType === 5;
          data.user.isFachberater = roleType === 6;
          data.user.isAgenturLeader = roleType === 7;
        }

        data.user.agentur_id = data.user.agentur_id ?? null;
        
        // Prüfen ob Benutzer als Teamleiter in sub_teamleiter Tabelle steht
        try {
          const teamleiterCheck = await checkIsSubTeamleiter(data.user.id);
          if (teamleiterCheck.success) {
            data.user.isSubTeamleiter = teamleiterCheck.isSubTeamleiter;
          } else {
            data.user.isSubTeamleiter = false;
          }
        } catch (err) {
          console.error('Fehler beim Prüfen des Teamleiter-Status:', err);
          data.user.isSubTeamleiter = false;
        }
        
        onLogin(data.user);
      } else {
        setError(data.error || 'Login fehlgeschlagen');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Login</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>E-Mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Passwort</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Bitte warten...' : 'Einloggen'}
        </button>
      </form>
      <div style={{ marginTop: '16px', textAlign: 'center' }}>
        <button 
          type="button"
          onClick={() => navigate('/forgot-password')}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#4a6de5', 
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: '14px'
          }}
        >
          Passwort vergessen?
        </button>
      </div>
    </div>
  );
}

export default Login;